export default function ZoneController($scope, $stateParams, DataService, MapService, MapDrawService, TitleService, NotificationService) {
	"ngInject";

	const vm = this;

	vm.$onInit = () => {
		vm.zoneId = $stateParams.zoneId;
		vm.loading = true;
		DataService.getZone(vm.zoneId).then((zone) => {
			TitleService.setTitleOrg(zone);

			vm.zone = zone;
			vm.assigned = DataService.getAssignedOrgs(vm.zone);
			vm.map = DataService.instantMap();
			vm.recenter();

			DataService.setMapOpts({selectedOrg: vm.zone, automaticOrgs: vm.assigned});

			vm.loading = false;
		}, NotificationService.exception(vm));
	};

	vm.recenter = () => {
		MapService.centerMap(vm.zone, vm.map);
	};

}
